import React from 'react';

import { Select as MuiSelect, SelectProps } from '@mui/material';

import ChevronDownIcon from './assets/chevron-down.svg';
import useStyles from './styles';

interface Props<T> extends Omit<SelectProps<T>, 'size'> {
    inverted?: boolean;
    size?: 'small' | 'medium' | 'large';
}

function Select<T>(props: Props<T>) {
    const { classes, cx } = useStyles();
    const { size = 'medium', inverted, ...restProps } = props;
    return (
        <MuiSelect
            {...restProps}
            variant="outlined"
            classes={{
                ...props.classes,
                root: cx(
                    classes.root,
                    {
                        [classes.large]: size === 'large',
                        [classes.medium]: size === 'medium',
                        [classes.small]: size === 'small',
                        [classes._inverted]: inverted
                    },
                    props.classes?.root
                ),
                select: cx(classes.select, { [classes._inverted]: inverted }, props.classes?.select),
                icon: cx(classes.icon, { [classes._inverted]: inverted }, props.classes?.icon)
            }}
            IconComponent={ChevronDownIcon}
            SelectDisplayProps={{ ...props.SelectDisplayProps, ['aria-controls']: 'none' }}
            MenuProps={{
                anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                transformOrigin: { vertical: 'top', horizontal: 'center' },
                ...props.MenuProps,
                classes: { ...props.MenuProps?.classes, list: cx(classes.list, props.MenuProps?.classes?.list) },
                className: cx(classes.menu, props.MenuProps?.className),
                PopoverClasses: {
                    ...props.MenuProps?.PopoverClasses,
                    paper: cx(classes.paper, props.MenuProps?.PopoverClasses?.paper)
                }
            }}
        />
    );
}

export default Select;
